export const APPLICATION_STRINGS = {
  PLEASE_LOGIN: 'Please login before placing an order.',
  ORDER_ONE_ITEM: 'Orders must have at least one associated item',
  ORDER_CANNOT_VOID: 'Orders cannot be voided in this state.',
  EMAIL_SENT: 'Email Sent!',
  EMAIL_FAILED_WITH_DATA: 'Email failed to send: ',
  EMAIL_FAILED: 'Email failed to send',
  TEXT_SENT: 'Text Sent!',
  TEXT_FAILED: 'Text failed to send',
  TEXT_FAILED_WITH_DATA: 'Text failed to send: ',
  SPLIT_TABS_OFFLINE_AUTH_ERROR:
    'Offline authorizations cannot be used to start a new tab. Please reauthorize the payment to split the tab.',
  SAF_ERROR: 'There was an issue syncing offline transactions. Please try again later.',
  TAB_STARTED: 'Success! New tab opened.',
  CLOSE_TAB_SUCCEEDED: 'Success! Tab Closed.',
  CLOSE_TAB_FAILED: 'Error! There was an error closing the tab.',
  VOID_PAYMENT_FAILED: 'Error! There was an error voiding payment.',
  UPDATE_PAYMENT_FAILED: 'Error! There was an updating payment.',
  TAB_UPDATED: 'Success! Tab has been updated.',
  TAB_UPDATE_FAILED: 'Error! There was an error adding items to the tab.',
  REFUND_ORDER_SUCCEEDED: 'Success! Refund completed.',
  REFUND_ORDER_FAILED: 'Error! There was an error refunding order items.',
  REFUND_ORDER_CANCELLED: 'Order has been cancelled.',
  REFUND_INTERAC_CONFIRMATION: 'Card must be present to perform Interac refund',
  PROMOTIONS_NOT_APPLIED: 'Not all promotions were applied',
  DISCOUNTS_APPLIED: 'Discounts applied.',
  EMAIL_BUTTON_LONG_TEXT: 'Email Receipt',
  TEXT_BUTTON_LONG_TEXT: 'Text Receipt',
  EMAIL_BUTTON_SHORT_TEXT: 'Email',
  TEXT_BUTTON_SHORT_TEXT: 'Text',
  PRINT_BUTTON_LONG_TEXT: 'Print Receipt',
  PRINT_BUTTON_SHORT_TEXT: 'Print',
  NEXT_BUTTON_NO_BALANCE: "I'm Done",
  QR_BUTTON_TEXT: 'QR Code',
  SCAN_DIGITAL_RECEIPT: 'Scan for digital receipt',
  QR_TOTAL: 'Total',
  NEXT_BUTTON_BALANCE: 'Continue to next tender',
  NETWORK_PRINTER_ERROR_TITLE: 'Network Printer Error',
  PPI_NETWORK_ERROR_MESSAGE:
    'Unable to get payment configurations. Please find a stable network connection and then sync network data.',
  ORDER_NOT_FOUND: 'Order not found',
  INTERNET_CONNECTION_REQUIRED: 'Sorry, internet connection required. Please try again once the connection is restored.',
  NETWORK_PRINTING_OFFLINE_ERROR: 'Network Printing is not supported while device is offline.',
  CANNOT_SPLIT_TAB_WHILE_OFFLINE:
    'Splitting is not supported for this tab while the device is offline. Please find a stable network connection.',
  CANNOT_TRANSFER_TAB_WHILE_OFFLINE:
    'Tab transfers are not supported for this tab while the device is offline. Please find a stable network connection.',
  TRANSFER_TABS_SUBTEXT: 'Search by name to select an attendant to take over this order',
  TRANSFER_TABS_NO_ATTENDANTS: 'No attendants found matching your criteria',
  TRANSFER_TABS_TOO_MANY_RESULTS: 'Too many matches—keep typing to see results',
  TRANSFER_TABS_BUTTON_NAME: 'Transfer Tab',
  NETWORK_PRINTING_RECEIPT_OFFLINE_ERROR:
    'Network printing is not supported while device is offline. Your receipt cannot be printed at this time.',
  NETWORK_PRINTING_SLIP_OFFLINE_ERROR:
    'Network Printing is not supported while device is offline. Your authorization slips cannot be printed at this time.',
  NETWORK_PRINTING_CHECK_OFFLINE_ERROR:
    'Network Printing is not supported while device is offline. Your check cannot be printed at this time.',
  ORDER_MUST_BE_SYNCED_BEFORE_PRINTING: 'Order must be synced before printing to the selected receipt printer.',
  SEND_RECEIPT_ERROR_TITLE: 'Receipt Error',
  ORDER_MUST_BE_SYNCED_BEFORE_SENDING_RECEIPT: 'Order must be synced before sending a receipt.',
  KITCHEN_PRINTER_ERROR_TITLE: 'Kitchen Printer Error',
  OFFLINE_KITCHEN_PRINTER_ERROR: 'This device is currently offline. Your order will not be sent to the kitchen.',
  OK_BUTTON_TEXT: 'OK',
  OKAY_BUTTON_TEXT: 'OKAY',
  YES_CONTINUE: 'YES, CONTINUE',
  NO_NEVERMIND: 'NO, NEVER MIND',
  ADD_TO_CART: 'Add to Cart',
  UPDATE: 'Update',
  SYNC_NOW_BUTTON_TEXT: 'SYNC NOW',
  SYNC_ORDERS: 'Sync Orders',
  STOP_SYNCING: 'Stop Syncing',
  AVAILABLE_BALANCE_LOOKUP_SUBTEXT: 'Available balance for use towards eligible purchases',
  AVAILABLE_BALANCE_LOOKUP_TICKET_SCAN_ERROR: 'That code did not work.',
  AVAILABLE_BALANCE_LOOKUP_TICKET_FUND_ERROR: 'No funds remain on this ticket. Please scan another ticket.',
  AVAILABLE_BALANCE_LOOKUP_QR_PAY_SCAN_ERROR: 'QR Code is not valid. Please try again.',
  AVAILABLE_BALANCE_LOOKUP_QR_PAY_FUND_ERROR: 'QR Code has expired. Please refresh your code and try again.',
  AVAILABLE_BALANCE_LOOKUP_GIFT_CARD_FUND_ERROR: 'Error requesting card balance. Please try again.',
  AVAILABLE_BALANCE_LOOKUP_GIFT_CARD_SCAN_ERROR: 'Card not recognized. Please try again.',
  AVAILABLE_BALANCE_TITLE: 'Balance Lookup',
  BALANCE_LOOKUP_NO_TENDERS_CONFIGURED: 'No loyalty tenders configured',
  INTERNET_CONNECTION_REQUIRED_AVAILABLE_BALANCE: 'Balance lookup unavailable when device offline.',
  PRICE_ADJUST_EXIT_CONFIRMATION:
    'Item price adjustment will not be applied if you exit without updating. Do you wish to continue?',
  PRICE_ADJUST_NOT_ALLOWED_OFFLINE_SYNCED_ORDER:
    'Price adjustments are not supported for this order while the device is offline. Please find a stable network connection.',
  OPEN_PRICE_RICH_CHECKOUT_ALERT: 'Orders containing open priced items cannot be paid by scanning from the Mobile App.',
  OPEN_PRICE_RICH_CHECKOUT_CLOSING_TABS_DIALOG:
    'Orders containing open priced items cannot be paid by scanning from the Mobile App. Please remove open priced items from your cart or select a different payment method to proceed.',
  TAX_EXEMPT_RICH_CHECKOUT_CLOSING_TABS_DIALOG:
    'Tax exempted orders cannot be paid by scanning from the Mobile App. Please select a different payment method to proceed.',
  PRICE_OVERRIDE_RICH_CHECKOUT_CLOSING_ORDER:
    'Prices cannot be adjusted for orders paid by Mobile App. Please remove price adjusted items from your cart or select a different payment method to proceed.',
  PRINTER_NOT_CONFIGURED_DIALOG_HEADER_TEXT: 'Printer Not Configured',
  PRINTER_NOT_CONFIGURED_DIALOG_SUB_HEADER_TEXT: 'You must have a printer configured to print a Refund Receipt',
  RECONNECTED_FETCHING_DATA: 'Reconnected - Retrieving card data...',
  CARD_READER_STATUS: 'Card Reader Status',
  CARD_PRESENT_REFUND_DIALOG: 'Customer refunding credit to card',
  PRINTER_NOT_CONFIGURED_DIALOG_CONFIGURE_PRINTER: 'CONFIGURE PRINTER',
  PRINTER_NOT_CONFIGURED_DIALOG_CANCEL: 'CANCEL',
  MANAGER_PIN_HEADER: 'Input Manager Pin',
  NEXT: 'NEXT',
  PROCESSING: 'Processing...',
  ADD_TO_TAB: 'Add to Tab',
  START_A_TAB: 'Start a Tab',
  PAY_NOW: 'Pay Now',
  AUTHORIZE_NOW: 'Authorize Card Now',
  AUTHORIZE_NEW_CARD: 'Authorize New Card',
  AUTHORIZE_LATER: 'Add Payment Later',
  CANNOT_REOPEN_WHILE_OFFLINE: 'Tabs cannot be reopened when device is offline',
  CANNOT_REOPEN_TAB: 'Cannot Reopen Tab',
  CANNOT_REOPEN_UNSYNCED_TAB: 'Order must be synced before reopening.',
  ENABLE_BARCODE_PRODUCT_SCANNING: 'Enable product barcode scanning',
  DISABLE_BARCODE_PRODUCT_SCANNING: 'Disable product barcode scanning',
  FAVORITES_INSTRUCTIONS: 'Add favorites by long pressing \n an item from the menu',

  // Menu
  NO_ITEM_FOUND: 'No items found',
  NO_ITEM_INSTRUCTIONS: 'Try searching "All" categories',
  ERROR_FETCH_CARD_TRANSACTION: 'There was an error fetching card transaction',
  NO_RESULTS: 'No results to display',
  SCAN_ITEMS_TO_CART: 'Scan Items to Add to Cart',
  BARCODE_NOT_RECOGNIZED: 'Barcode not recognized',
  MAX_AMOUNT_REACHED: 'Item cannot be added. Maximum amount reached.',
  EMPTY_CART: 'Your cart is empty',
  TAP_OR_SCAN_TO_ADD_ITEMS: 'Tap or Scan Items to Add to Cart',
  CART_CLEARED: 'Your cart has been cleared.',

  // Barcode Scanning Settings Config
  BARCODE_SCANNING_SETTINGS: 'Barcode Scanning Settings',
  DISPLAY_SCANNABLE_ITEMS: 'Display Scannable Items',
  DISABLE_BARCODE_SCANNING: 'Disable product barcode scanning',
  ENABLE_BARCODE_SCANNING: 'Enable product barcode scanning',
  BARCODE_SCANNING_DISABLED_MOBILE: 'Barcode scanning is not supported on this device',

  // SYNCING STRINGS
  STOP_SYNC_TO_VIEW_ORDERS: 'Orders are currently being synced. Please stop the sync to view orders.',
  STOP_SYNC_WARNING:
    'These functions are not supported while a sync is in progress.  Stopping the sync will leave some orders unsynced.',
  STOP_SYNC_NOW: 'Stop Sync Now',
  CANCEL_SYNC: 'CANCEL',
  CONTINUE_SYNC: 'Continue Sync',
  NOT_SYNCING: 'Not Syncing',
  CURRENTLY_SYNCING: 'Syncing...',
  LOADING: 'Loading...',
  SYNCING_ORDER_DETAILS: 'Syncing Order Details',
  SYNCING_CARD_READER: 'Syncing Card Reader Data',
  SYNCING_STATUS: 'Updating Order Status',
}
